module.exports = __webpack_public_path__ + "static/media/account-service-img.1082e8e0.png";